import { formatDuration, intervalToDuration } from "date-fns";
import { useLocale, useTranslations } from "next-intl";
import type { DiscountListItemType } from "@/features/cart/types/discount.type";
import { getDateLocale } from "@/features/cart/utils/dates";

export const DiscountValidity = ({
  validity,
}: {
  validity: DiscountListItemType["validity"];
}) => {
  const t = useTranslations();
  const locale = useLocale();
  const dateLocale = getDateLocale(locale);

  if (validity.type === "date_range") {
    const duration = intervalToDuration({
      start: new Date(),
      end: new Date(validity.endAt as string),
    });
    const timeRemaining = formatDuration(duration, {
      locale: dateLocale,
      format: ["months", "days", "hours"],
      delimiter: ", ",
    });
    return <p>{t("discounts.validity.daysRemaining", { timeRemaining })}</p>;
  }
  if (validity.type === "until_stock_ends") {
    return <p>{t("discounts.validity.untilStockEnds")}</p>;
  }
  if (validity.type === "unlimited") {
    return <p>{t("discounts.validity.unlimited")}</p>;
  }
  return null;
};
